import { gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './CategoryBadge.module.scss';
import { getCategoryString } from './utils';

interface CategoryBadgeProps {
    category?: string;
    subcategory?: string;
}

export const CategoryBadge = ({
    category,
    subcategory,
}: CategoryBadgeProps) => {
    const categoryString = getCategoryString(category, subcategory);

    if (!categoryString) {
        return null;
    }

    return (
        <div className={styles.categoryBadge} data-testid="category-badge">
            <span className={styles.categoryBadgeTitle}>
                {gettext('Category: ')}
            </span>
            {categoryString}
        </div>
    );
};
